export default "__VITE_ASSET__f242967c__"